import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/catering/title.png'
import _imports_1 from '../../assets/img/catering/rlgt_icon.png'


const _hoisted_1 = { class: "catering-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("h2", null, "Catering"),
  /*#__PURE__*/_createVNode("div", { class: "img" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "catering-list" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "item",
    style: {"padding":"62.037vw 0 21.7593vw 14.3519vw"}
  }, [
    /*#__PURE__*/_createVNode("div", { class: "particles" }),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"6.6667vw"} }, "谁能不爱"),
    /*#__PURE__*/_createVNode("div", {
      style: {"width":"63.4259vw"},
      class: "line"
    }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_1,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"6.6667vw"} }, "的川菜呢！"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#a3771a","margin-left":"-1.1111vw"} }, "#来一趟四川外国游客被美食征服了#"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#a3771a","margin-left":"-1.1111vw"} }, "#外国游客被大熊猫和川菜硬控#"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#a3771a","margin-left":"-1.1111vw"} }, "#美国财政部长耶伦抵达北京直奔川菜馆#")
  ]),
  /*#__PURE__*/_createVNode("div", {
    class: "item",
    style: {"padding-bottom":"35.1852vw"}
  }, [
    /*#__PURE__*/_createVNode("p", { class: "label" }, "据四川省商务厅监测的138家餐饮企业数据"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.6296vw","color":"#b88d29","line-height":"1.62"} }, "2024年春节假期"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.6296vw","color":"#b88d29","line-height":"1.62"} }, "四川省餐饮业"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.6296vw","color":"#b88d29","line-height":"1.62"} }, "实现营业额"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.6296vw","color":"#b88d29","line-height":"1.62","margin":"2.7778vw 0 31.4815vw"} }, [
      /*#__PURE__*/_createVNode("span", {
        class: "count-up",
        style: {"font-size":"26.7593vw","color":"#e27933","font-family":"'jdzh'","line-height":"1"}
      }, "13.3"),
      /*#__PURE__*/_createTextVNode("亿元")
    ]),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.6296vw","color":"#b88d29","line-height":"1.62"} }, "同比增长"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"16.9444vw","font-family":"'jdzh'","color":"#e27933","line-height":"1","margin":".9259vw 0 3.7037vw"} }, [
      /*#__PURE__*/_createVNode("span", { class: "count-up" }, "23.5"),
      /*#__PURE__*/_createTextVNode("%")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "echarts echarts-1" }),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.6296vw","color":"#b88d29","line-height":"1.62"} }, "较2019年同期增长"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"16.9444vw","font-family":"'jdzh'","color":"#e27933","line-height":"1","margin":".9259vw 0 4.6296vw"} }, [
      /*#__PURE__*/_createVNode("span", { class: "count-up" }, "64.3"),
      /*#__PURE__*/_createTextVNode("%")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "echarts echarts-2" })
  ]),
  /*#__PURE__*/_createVNode("div", {
    class: "item",
    style: {"padding-bottom":"20.3704vw"}
  }, [
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#b88d29","line-height":"1.33"} }, "吃饭是每个人的大事，更是国之大事"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#b88d29","line-height":"1.33"} }, "它犹如一面镜子"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#b88d29","line-height":"1.33"} }, "折射出的是社会生活精神面貌"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#b88d29","line-height":"1.33"} }, "和经济发展变化的状况"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#b88d29","line-height":"1.33"} }, "更承载着人们对美好生活的向往"),
    /*#__PURE__*/_createVNode("p", {
      class: "label",
      style: {"margin":"2.7778vw 0 6.4815vw"}
    }, "2014年—2023年中国餐饮市场总收入（亿元）"),
    /*#__PURE__*/_createVNode("div", { class: "echarts echarts-3" }),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#a06a3d","line-height":"1.333","margin-bottom":"1.3889vw"} }, "2023年全年，全国餐饮收入"),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#a06a3d","line-height":"1.333"} }, [
      /*#__PURE__*/_createVNode("span", {
        class: "count-up",
        style: {"font-size":"20.5556vw","line-height":"1","color":"#e27933","font-family":"'jdzh'"}
      }, "52890"),
      /*#__PURE__*/_createTextVNode("亿元")
    ]),
    /*#__PURE__*/_createVNode("p", { style: {"font-size":"4vw","color":"#a06a3d","line-height":"1.333"} }, "规模创历史新高")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "item end-item" }, [
    /*#__PURE__*/_createVNode("p", null, "餐饮产业的持续快速增长"),
    /*#__PURE__*/_createVNode("p", null, "使其经济贡献稳居服务业前列"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("p", null, "2024年上半年"),
    /*#__PURE__*/_createVNode("p", null, "全国餐饮收入达到"),
    /*#__PURE__*/_createVNode("div", { class: "echarts-4-wrapper" }, [
      /*#__PURE__*/_createVNode("div", { class: "echarts echarts-4" }),
      /*#__PURE__*/_createVNode("p", { style: {"color":"#e27933","font-size":"4.4444vw","font-family":"'jdzh'","line-height":"1"} }, [
        /*#__PURE__*/_createVNode("span", {
          class: "count-up",
          style: {"font-size":"10.3704vw"}
        }, "26243"),
        /*#__PURE__*/_createTextVNode("亿元")
      ]),
      /*#__PURE__*/_createVNode("p", { style: {"color":"#e27933","font-size":"4.4444vw","font-family":"'jdzh'","line-height":"1"} }, [
        /*#__PURE__*/_createTextVNode("同比增长"),
        /*#__PURE__*/_createVNode("span", {
          class: "count-up",
          style: {"font-size":"10.3704vw"}
        }, "7.9"),
        /*#__PURE__*/_createTextVNode("%")
      ])
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode("增速比商品零售额快"),
      /*#__PURE__*/_createVNode("span", {
        class: "count-up",
        style: {"font-size":"10.3704vw","line-height":"1","color":"#e27933","font-family":"'jdzh'"}
      }, "4.7"),
      /*#__PURE__*/_createTextVNode("个百分点")
    ]),
    /*#__PURE__*/_createVNode("p", { style: {"margin-top":"5.5556vw"} }, [
      /*#__PURE__*/_createTextVNode("对社零增长的贡献率达到了"),
      /*#__PURE__*/_createVNode("span", { style: {"font-size":"10.3704vw","line-height":"1","color":"#e27933","font-family":"'jdzh'"} }, [
        /*#__PURE__*/_createVNode("b", {
          style: {"font-weight":"normal"},
          class: "count-up"
        }, "22.8"),
        /*#__PURE__*/_createTextVNode("%")
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}